import { createApiClient, responseData } from '#lib/api/client.js';

export const getPrimaryCart = async (
	fetchFn: typeof globalThis.fetch,
	productIds: string[]
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/cart/primary', {
			params: { query: { productIds: productIds.join(',') } },
		})
	);
